<template>
  <font-awesome-icon
    :icon="checked ? icon.checked : icon.nonChecked"
    v-bind:class="{ checked_icon: checked }"
    @click="onClick"/>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faSquare} from '@fortawesome/pro-regular-svg-icons';
import {faCheckSquare} from '@fortawesome/pro-solid-svg-icons';
export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean
    }
  },
  data () {
    return {
      icon: {
        checked: faCheckSquare,
        nonChecked: faSquare
      },
      isChecked: this.checked
    };
  },
  methods: {
    onClick () {
      this.isChecked = !this.isChecked;
      this.$emit('change', this.isChecked);
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../../stylesheets/variables.scss";
  .checked_icon {
    color: $active;
  }

  [check-size="xs"] {
    font-size: $fs-xs;
  }
  [check-size="s"] {
    font-size: $fs-s;
  }
  [check-size="m"] {
    font-size: $fs;
  }
  [check-size="l"] {
    font-size: $fs-l;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/forms/SimpleCheckbox.vue